import React , {useState , useEffect} from 'react';
import { Row , Col } from 'react-bootstrap';
import Button from '../../components/common/Button/Button';
import './menu.css';
import { showToast } from '../../components/common/ToastNotification/ToastNotification';
import { FaArrowLeftLong } from "react-icons/fa6";
import FormInput from '../../components/common/FormInput/FormInput';
import { addMenu , getMenuById , updateMenu } from '../../api/service/menu.service';
import { useNavigate, useParams } from 'react-router-dom';

const AddMenu = () => {
    let { id } = useParams()
    let navigate = useNavigate()
    const [loading , setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name : "",
        priority : "",
        slug : "",
        is_customizable : false
    });

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async () => {
        try {
            const data = new FormData();
            data.append("name", formData.name);
            data.append("priority", formData.priority);
            data.append("slug" , formData.slug);
            data.append("is_customizable", formData.is_customizable ? 1 : 0);
            let response =  await addMenu(data);
        
            showToast.success(response?.message || "Menu added successfully!");
        
            navigate("/menu")
            setFormData({
                name : "",
                priority : "",
                slug : "",
                is_customizable : false
            });
        } catch (error) {
            console.error("Error adding blog:", error);
            showToast.success(error?.message || "Failed to create menu!");
        }
    };

    useEffect(() => {
        const fetchMenuDetails = async () => {
          try {
            const response = await getMenuById(id);
            if (response && response.data) {
              const menu = response.data;
              setFormData({
                name  : menu.name,
                priority : menu.priority || "",
                slug : menu.slug ,
                is_customizable : menu.is_customizable
              });
            }
          } catch (error) {
            console.error("Fetch Error:", error);
            showToast.error("Failed to load menu details.");
          } finally {
            
          }
        };
        
        if (id) fetchMenuDetails();
    }, [id]);

    const handleUpdate = async (e) => {
        e.preventDefault();
    
        if (!formData.name) {
          showToast.error("Please enter menu title");
          return;
        }
        
        if (!formData.priority) {
          showToast.error("Please enter priority");
          return;
        }

        if (!formData.priority) {
          showToast.error("Please enter slug");
          return;
        }
    
        try {
          setLoading(true);
          const submitData = new FormData();
          submitData.append("menu_id" , id);
          submitData.append("name", formData.name);
          submitData.append("priority", formData.priority);
          submitData.append("slug", formData.slug);
          submitData.append("is_customizable", formData.is_customizable ? 1 : 0);
          const response = await updateMenu(submitData);
          
          if (response.success) {
            showToast.success("Menu updated successfully!");
            setTimeout(() => {
              navigate("/menu"); 
            }, 1000);
          } else {
            showToast.error(response.message || "Failed to update menu");
          }
        } catch (error) {
          console.error("Update Error:", error);
          showToast.error(error.response?.data?.message || "Failed to update menu");
        } finally {
          setLoading(false);
        }
      };
    
    
    return (
        <>
            <div className="d-flex gap-2 align-items-center mb-3">
                <FaArrowLeftLong
                    color="#000"
                    style={{ cursor: "pointer" }}
                    onClick={() => window.history.back()}
                />
                <h3 className="management-tile mb-0 ml-2">{id ? 'Upadte Menu' : 'Add Menu'}</h3>
            </div>

            <form onSubmit={id ? handleUpdate : handleSubmit}>
                <Row>
                    <Col xs={12} className="mb-3">
                        <label className="form-label">Menu name</label>
                        <FormInput 
                            name="name"
                            value={formData.name}
                            placeholder="name"
                            onChange={(e) => handleChange("name", e.target.value)}
                            required
                        />
                    </Col>
                    <Col xs={12} className="mb-3">
                        <label className="form-label">Priority</label>
                        <FormInput 
                            name="priority"
                            value={formData.priority}
                            onChange={(e) => handleChange("priority", e.target.value)}
                            placeholder="e.g 1 , 2"
                            required
                        />
                    </Col>
                    <Col xs={12} className="mb-3">
                        <label className="form-label">Slug</label>
                        <FormInput 
                            name="slug"
                            value={formData.slug}
                            onChange={(e) => handleChange("slug", e.target.value)}
                            placeholder="slug"
                            required
                        />
                    </Col>
                    <Col xs={12} className="mb-3" style={{display:'flex' , gap:'10px'}}>
                        <input
                          type="checkbox"
                          name="is_customizable"
                          checked={formData.is_customizable}
                          onChange={(e) => handleChange("is_customizable", e.target.checked)}
                          style={{cursor:'pointer'}}
                        />
                        <label className="form-label" style={{marginTop:'7px'}}>Custom Page</label>
                    </Col>
                    <Col xs={12} className="mb-3">
                        <Button onClick={ id ? handleUpdate : handleSubmit}>{id ? 'Update' : 'Add'}</Button>
                    </Col>
                </Row>
            </form>

        </>
    )
}

export default AddMenu